import React from 'react';
import Control from '../store/control';
import Type from './type';
import SideWorkflow from './workflow';
import ShowCheckbox from './showcheckbox';
import SideViewChanger from './viewchanger';
import SideFormBk from '../formBk/form';
import SideFormAk from '../formAk/form';
import SideFormSoftInsert from '../formSoftInsert/form';
import SideFormAfo from '../formAfo/form';

const SideBar = () => {
  const prosthetics = Control.Get('prosthetics');
  const type = Control.Get('type');

  return (
    <div>
      {/* <TitleBar /> */}
      <Type />
      <SideViewChanger />
      <SideWorkflow />
      <ShowCheckbox />

      {(prosthetics == 'BK') && ((type == 'TestSocket') || (type == 'FinalDevice') || (type == 'FinalDeviceFinalStep')) ? <SideFormBk /> : null}
      {(prosthetics == 'AK') && ((type == 'TestSocket') || (type == 'FinalDevice')) ? <SideFormAk /> : null}
      {(type == 'SoftInsert') ? <SideFormSoftInsert /> : null}
      {(prosthetics == 'LLO') && ((type == 'AFO')) ? <SideFormAfo /> : null}
    </div>
  )
};
export default SideBar;
